<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/midan/table">米单列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="配置名称"
                          prop="name">
              <el-input v-model="form.name" disabled
                        placeholder="请输入配置名称">
              </el-input>
            </el-form-item>
            <el-form-item label="虚拟任务项目"
                          prop="projectid">
              <remote-select
                  disabled
                  class="width-max"
                  clearable
                  id-key="number"
                  label-key="name"
                  value-key="id"
                  placeholder="输入项目名称/编号 关键字搜索"
                  v-model="form.projectid"
                  @change="() => { form.batchid = '' }"
                  :query-request="(_) => getProjectTable(Object.assign({customerid: form.customerid, type: [supportProjectType]}, _))"
                  :find-request="getProjectDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="虚拟任务批次"
                          prop="batchid">
              <remote-select
                  class="width-max"
                  clearable
                  id-key="number"
                  label-key="detail"
                  value-key="id"
                  placeholder="输批次名称/编号 关键字搜索"
                  v-model="form.batchid"
                  disabled
                  :query-request="(_)=>getBatchTable(Object.assign({projectid:form.projectid, per_page: 100}, _))"
                  :find-request="getBatchDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="虚拟任务标题"
                          prop="title">
              <el-input v-model="form.title" disabled
                        placeholder="请输入虚拟任务标题">
              </el-input>
            </el-form-item>
            <el-form-item label="最大任务数量"
                          prop="max_tsk_cnt">
              <el-input v-model="form.max_tsk_cnt" disabled
                        placeholder="请输入最大任务数量">
              </el-input>
            </el-form-item>
            <el-form-item label="最小任务数量"
                          prop="min_tsk_cnt">
              <el-input v-model="form.min_tsk_cnt" disabled
                        placeholder="请输入最小任务数量">
              </el-input>
            </el-form-item>
            <el-form-item label="任务半径"
                          prop="radius">
              <el-input v-model="form.radius" :disabled="form.status > 0"
                        placeholder="请输入任务半径">
                <template slot="append">KM</template>
              </el-input>
            </el-form-item>
            <el-form-item label="生效地区"
                          prop="province_setting">
              <div v-for="(item, index) in form.province_setting" :key="index">
                <el-select v-model="item.id"
                       disabled
                       class="width-max"
                       style="width: 30%  !important"
                       @change="id => selectProvince(index, id)"
                       clearable
                       placeholder="请选择省">
                  <el-option
                    v-for="(item, index) in provinces"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-select v-model="item.city_ids"
                       disabled
                       multiple
                       class="width-max"
                       clearable
                       placeholder="请选择市">
                  <el-option
                    v-for="(item, index) in item.cities"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="额外赏金比例"
                          prop="bonus_rate">
              <el-input v-model="form.bonus_rate"
                        placeholder="请输入额外赏金比例" disabled>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="最少完成任务数"
                          prop="min_finish_cnt">
              <el-input v-model="form.min_finish_cnt"
                        placeholder="请输入最少完成任务数" disabled>
                <template slot="append">单</template>
              </el-input>
            </el-form-item>
            <el-form-item label="零豆惩罚比例"
                          prop="point_penalty_rate">
              <el-input v-model="form.point_penalty_rate"
                        placeholder="请输入零豆惩罚比例" disabled>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <div v-for="(item, index) in form.project_setting" :key="index">
              <el-form-item label="项目">
                <remote-select
                    disabled
                    class="width-max"
                    clearable
                    id-key="number"
                    style="width: 78.3%  !important"
                    label-key="name"
                    value-key="id"
                    placeholder="输入项目名称/编号 关键字搜索"
                    v-model="item.id"
                    @change="() => { item.batch_ids = [] }"
                    :query-request="(_) => getProjectTable(Object.assign({type: [supportProjectType]}, _))"
                    :find-request="getProjectDetail">
                </remote-select>
              </el-form-item>
              <el-form-item label="任务批次">
                <remote-select
                    class="width-max"
                    clearable
                    multiple
                    style="width: 78.3%  !important"
                    id-key="number"
                    label-key="detail"
                    value-key="id"
                    placeholder="输批次名称/编号 关键字搜索"
                    v-model="item.batch_ids"
                    disabled
                    :query-request="(_)=>getBatchTable(Object.assign({projectid:item.id, per_page: 100}, _))"
                    :find-request="getBatchDetail">
                </remote-select>
              </el-form-item>
            </div>
          </div>
        </div>
        <el-form-item>
          <el-button @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <MidanPreviewDialog
      :visible="showPreview"
      :data="previewData"
      @confirm="confirmSetting"
      @closeDialog="showPreview = false"></MidanPreviewDialog>
  </div>
</template>

<script>
import CascaderDistrict from '@/views/area/components/CascaderDistrict'
import { formRules } from '../midan.rules.js'

import MidanPreviewDialog from '../components/MidanPreviewDialog.vue'

export default {
  components: {
    CascaderDistrict,
    MidanPreviewDialog
  },
  data () {
    return {
      id: 0,
      formRules,
      form: {
        name: '',
        customerid: 445,
        projectid: '',
        batchid: '',
        title: '',
        radius: '',
        max_tsk_cnt: '',
        min_tsk_cnt: '',
        min_finish_cnt: '',
        bonus_rate: 0,
        point_penalty_rate: '',
        status: 0,
        province_setting: [
          {
            id: '',
            city_ids: [],
            cities: [],
          }
        ],
        project_setting: [
          {
            id: '',
            batch_ids: [],
          }
        ],
      },
      areaid: [],
      showPreview: false,
      previewData: {},
      provinces: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      projectOpts: state => state.customerProject
    }),
    supportProjectType () {
      return this.projectOpts.TYPE_NORMAL
    }
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {
    this.appendFormRules()
    request('getProvinces').then(({data}) => {
      this.provinces = data
    })
  },
  mounted () {},
  methods: {
    ...request.map([
      'getCustomerTable',
      'getCustomerDetail',
      'getProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
    ]),
    appendFormRules () {
      let validate = {
        next: 0,
        field: (value) => {
          if (++validate.next === 4) {
            validate.next = 0
          } else {
            // 确保不会重复执行，在使用 form.validate 时对每个字段进行了轮询验证
            let next = validate.next
            setTimeout(() => {
              if (validate.next === next) {
                this.$refs.form.validateField(value)
              }
            })
          }
        },
        fail () {
          validate.next = 0
        },
      }
    },
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getMidanDetail', {id}).then(({data}) => {
        data.projectid = `${data.projectid}`
        data.batchid = `${data.batchid}`
        data.radius = data.radius / 1000
        data.province_setting.forEach(item => {
          item.cities = []
        })
        filter.setLoop(this.form, data)
        for (let i = 0; i < this.form.province_setting.length; i++) {
          this.form.province_setting[i].cities = []
          this.selectProvince(i, this.form.province_setting[i].id)
        }
      })
    },
    getForm () {
      const form = filter.copyJson(this.form)
      form.province_setting = form.province_setting.map(item => {
        return {
          id: item.id,
          city_ids: item.city_ids
        }
      })
      return form
    },
    onSubmit () {
      if (this.form.max_tsk_cnt < this.form.min_tsk_cnt) {
        this.$message.error('分组最大任务数不能小于分组最小任务数！')
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          request.common('previewInfo', this.getForm()).then(({data}) => {
            this.showPreview = true
            this.previewData = data
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    confirmSetting () {
      this.id ? this.update(this.id) : this.create()
    },
    create () {
      this.showPreview = false
      request.common('createMidanData', this.getForm()).then((res) => {
        this.showPreview = false
        this.previewData = []
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/midan/table/'})
        })
      })
    },
    update (id) {
      request.common('updateMidanData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/midan/table/'})
        })
      })
    },
    onAddProject () {
      this.form.project_setting.push({
        id: '',
        batch_ids: [],
      })
    },
    onRemoveProject (index) {
      this.form.project_setting.splice(index, 1)
    },
    onAddCity () {
      this.form.province_setting.push({
        id: '',
        city_ids: [],
        cities: [],
      })
    },
    onRemoveCity (index) {
      this.form.province_setting.splice(index, 1)
    },
    onGetProvinceInfo (value) {
      if (value.length === 3) {
        this.form.provinceid = value[0]
        this.form.cityid = value[1]
        this.form.areaid = value[2]
      }
    },
    selectProvince (index, pid) {
      if (pid) {
        request.alert('getCities', {pid}).then(({data}) => {
          this.form.province_setting[index].cities = data
        })
      } else {
        this.form.province_setting[index].cities = []
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/midan/pages/MidanDetail.vue